import { render, staticRenderFns } from "./SpacesTable.vue?vue&type=template&id=b2571c1c&scoped=true"
import script from "./SpacesTable.vue?vue&type=script&lang=ts"
export * from "./SpacesTable.vue?vue&type=script&lang=ts"
import style0 from "./SpacesTable.vue?vue&type=style&index=0&id=b2571c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2571c1c",
  null
  
)

export default component.exports